import {GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {DataFrameRow} from 'data-frames/DataFrameTypes';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';

import {getFlagRowsStepSystemNamesFromAncestorSteps} from './getDataFrameRenderOverrides';

export function getFlaggedRowsFromDataFrame(
  analysis: PipelineGraphQL,
  step: GetAnalysisPipelineStep,
  dataFrameRows: Array<DataFrameRow>
): Set<string> {
  const {flagColumn} = getFlagRowsStepSystemNamesFromAncestorSteps(analysis, step);
  if (flagColumn == null) {
    return new Set();
  }
  const selectedRows = new Set<string>();
  dataFrameRows.forEach((row: DataFrameRow, index: number) => {
    if (row[flagColumn] === true) {
      selectedRows.add(index.toString());
    }
  });
  return selectedRows;
}
